export const SECONDARY = {
  DARKEST: '#003366',
  DARKER: '#004B96',
  DARK: '#095DB0',
  DEFAULT: '#1976D2',
  LIGHT: '#ACDCE5',
  LIGHTER: '#E0F3F5',
  LIGHTEST: '#F0FDFF',
} as const;
